export function isDevToolsOpen(): boolean {
  const threshold = 160;

  // 整个浏览器的宽度 - 视口宽度
  const widthThreshold = window.outerWidth - window.innerWidth > threshold;
  // 整个浏览器高度 - 视口高度
  const heightThreshold = window.outerHeight - window.innerHeight > threshold;
  const isDevToolsOpen = widthThreshold || heightThreshold;

  return isDevToolsOpen;

}
